import { useEffect } from 'react';

/**
 * Fires the supplied callback on mount. Using this instead of directly using useEffect saves us eslint warnings.
 */
export const useOnMount = cb => {
  // eslint-disable-next-line react-hooks/exhaustive-deps, react-hooks-static-deps/exhaustive-deps
  useEffect(cb, []);
};